import { authFetch } from '../AuthFetch';

export const findAuthRoles = () => (
  (dispatch) => {
    let url = '/auth/roles'
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_AUTH_ROLES',
        payload: json
      });
    });
  }
);


// WEBPACK FOOTER //
// ./src/actions/authActions.js